import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['container'];

  closeMessageBox = () => {
    this.containerTarget.style.opacity = 0;
    setTimeout(() => this.containerTarget.remove(), 600);
  };
}
